import * as PIXI from "pixi.js"
import { progressBar } from "./AssetsProgressBar";
import { config } from "./settings";


export const app = new PIXI.Application({
  width: config.originalWidth,
  height: config.originalHeight,
  backgroundColor: 0x000000,
  antialias: false,
 resolution: 2,
  backgroundAlpha: 0,
});

function appTransform (x, y) {
  app.view.style.width = x + "px";
  app.view.style.height = y + "px";
}

progressBar.position.set(
  app.screen.width / 2,
  app.screen.height / 2
)
app.stage.addChild(progressBar)
appTransform(700);
